import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, limit, onSnapshot, orderBy, query, Timestamp, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import { 
    FormControl, InputLabel, MenuItem, Select, TextField, Grid, Card, 
    CardContent, Typography, IconButton, Paper, Table, TableBody, 
    TableCell, TableContainer, TableHead, TableRow, Divider 
} from '@mui/material';
import moment from 'moment';
import { ClipLoader } from 'react-spinners';
import Menu from '../../panel/Menu';

const steps = ['Room Details', 'Customer Details', 'Payment Details'];
const today = new Date().toISOString().split('T')[0];

export default function Advancebooking() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers();
        });
    });

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const [loadincount, setloadincount] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [roomtypes, setroomtypes] = useState([]);
    const [subpaymodes, setsubpaymodes] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [companydetails, setcompanydetails] = useState([]);
    const [bookingtypes, setbookingtypes] = useState([]);
    const [rooms, setrooms] = useState([]);
    const [plans, setplans] = useState([]);

    const [bookingrooms, setbookingrooms] = useState([]);
    const [bookedRoomsDb, setBookedRoomsDb] = useState([]); // Added for filtering

    const [companyid, setcompanyid] = useState("");
    const [username, setusername] = useState();
    const [userData, setUserData] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const [bookingDate, setbookingDate] = useState(moment().format('YYYY-MM-DD'));
    const [checkindate, setcheckindate] = useState(moment().format('YYYY-MM-DD'));
    const [checkoutdate, setcheckoutdate] = useState(moment().add(1, 'days').format('YYYY-MM-DD'));
    const [noofdays, setnoofdays] = useState(1);
    const [checkintime, setcheckintime] = useState(moment().format('HH:mm A'));
    const [checkouttime, setcheckouttime] = useState('12:00 PM');
    const [adults, setadults] = useState(2);
    const [childs, setchilds] = useState(0);
    const [noofrooms, setnoofrooms] = useState(0);
    
    // Customer Details
    const [custname, setcustname] = useState("");
    const [mobile, setmobile] = useState("");
    const [email, setemail] = useState("");
    const [address, setaddress] = useState("");
    const [city, setcity] = useState("");
    const [state, setstate] = useState("Maharashtra");
    const [gender, setgender] = useState("Male");
    const [visitpurpose, setvisitpurpose] = useState("Darshan");
    const [gstname, setgstname] = useState("");
    const [gstno, setgstno] = useState("");
    const [bookingsource, setbookingsource] = useState("Walking");
    const [documenttype, setdocumenttype] = useState("");
    const [idno, setidno] = useState("");

    const [visitorPhotoUrl, setvisitorPhotoUrl] = useState('');
    const [idFrontUrl, setidFrontUrl] = useState('');
    const [idBackUrl, setidBackUrl] = useState('');
    const [couplePhotoUrl, setcouplePhotoUrl] = useState('');

    // Payment Details
    const [paymode1, setpaymode1] = useState("");
    const [amount1, setamount1] = useState(0);
    const [paytime1, setpaytime1] = useState(moment().format('YYYY-MM-DD HH:mm A'));
    const [utr1, setutr1] = useState(""); // Added UTR 1
    
    const [paymode2, setpaymode2] = useState("");
    const [amount2, setamount2] = useState(0);
    const [paytime2, setpaytime2] = useState(moment().format('YYYY-MM-DD HH:mm A'));
    const [utr2, setutr2] = useState(""); // Added UTR 2

    const [rooamount, setrooamount] = useState(0);
    const [totalamount, settotalamount] = useState(0);
    const [advance, setadvance] = useState(0);
    const [remaining, setremaining] = useState(0);
    const [note, setnote] = useState("");

    const [rtypeid, setrtypeid] = useState("");
    const [roomid, setroomid] = useState("");
    const [planid, setplanid] = useState("");
    const [amount, setamount] = useState(0);
    const [discountupto, setdiscountupto] = useState(0);
    const [discount, setdiscount] = useState(0);
    const [roomrate, setroomrate] = useState(0);

    const [bookingType, setbookingType] = useState("Confirm");
    const [payStatus, setpayStatus] = useState("Paid");
    const [search, setSearch] = useState("");

    useEffect(() => {
        fetchData1();
    }, []);

    // Fetch overlapping bookings when dates change to filter out already booked rooms
    useEffect(() => {
        const fetchOverlappingBookings = async () => {
            try {
                const q = query(collection(db, 'advancebookings'));
                const snapshot = await getDocs(q);
                let bookedIds = [];
                
                snapshot.forEach(doc => {
                    const data = doc.data();
                    // If status is not cancelled and dates overlap
                    if (data.status !== 'Cancelled' && data.checkindate < checkoutdate && data.checkoutdate > checkindate) {
                        if (data.rooms && Array.isArray(data.rooms)) {
                            data.rooms.forEach(r => bookedIds.push(r.roomid));
                        }
                    }
                });
                setBookedRoomsDb(bookedIds);
            } catch (error) {
                console.log("Error fetching booked rooms: ", error);
            }
        }
        if (checkindate && checkoutdate) {
            fetchOverlappingBookings();
        }
    }, [checkindate, checkoutdate]);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handlemobile = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length <= 10) {
            setmobile(value);
        }
    }

    const fetchData1 = async () => {
        try {
            const q111 = query(collection(db, 'plans'))
            onSnapshot(q111, (querySnapshot) => {
                if (querySnapshot.size > 0) {
                    let today = moment().format('YYYY-MM-DD');
                    let enddate = querySnapshot.docs[0].data().enddate;
                    if (today > enddate) {
                        window.location.href = "/plan-expired"
                    }
                }
            });

            const qc = query(collection(db, 'companydetails'), orderBy('createdAt', 'asc'))
            onSnapshot(qc, (querySnapshot) => {
                setcompanydetails(querySnapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })));
            });

            const q = query(collection(db, 'roomtypes'), orderBy('createdAt', 'asc'))
            onSnapshot(q, (querySnapshot) => {
                setroomtypes(querySnapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })));
            });

            const q22 = query(collection(db, 'subpaymodes'), orderBy('createdAt', 'asc'))
            onSnapshot(q22, (querySnapshot) => {
                setsubpaymodes(querySnapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })));
            });

            const q1 = query(collection(db, 'paymentmodes'), orderBy('createdAt', 'asc'))
            onSnapshot(q1, (querySnapshot) => {
                setpaymodes(querySnapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })));
            });

            const q2 = query(collection(db, 'bookingtypes'), orderBy('createdAt', 'asc'))
            onSnapshot(q2, (querySnapshot) => {
                setbookingtypes(querySnapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })));
            });

        } catch (error) {
            Toast.fire({ icon: "error", title: error.message });
        }
    }

    const handleDate1Change = (event) => {
        if (event.target.value < today) {
            setcheckindate(moment().format('YYYY-MM-DD'));
            handleDateChange(moment().format('YYYY-MM-DD'), checkoutdate);
            setcheckoutdate(moment().add(1, 'days').format('YYYY-MM-DD'));
        } else {
            setcheckindate(event.target.value);
            handleDateChange(event.target.value, moment(event.target.value).add(1, 'days').format('YYYY-MM-DD'));
            setcheckoutdate(moment(event.target.value).add(1, 'days').format('YYYY-MM-DD'));
        }
    };

    const handleDate2Change = (event) => {
        if (event.target.value < today) {
            setcheckoutdate(moment().add(1, 'days').format('YYYY-MM-DD'));
            handleDateChange(checkindate, moment().add(1, 'days').format('YYYY-MM-DD'));
        } else {
            setcheckoutdate(event.target.value);
            handleDateChange(checkindate, event.target.value);
        }
    };

    const handleDateChange = (date1, date2) => {
        if (date1 && date2) {
            const momentDate1 = moment(date1);
            const momentDate2 = moment(date2);
            const diffInDays = momentDate2.diff(momentDate1, 'days');
            if (diffInDays === 0) {
                setnoofdays(1);
                calFinalTotal(1, rooamount);
            } else {
                setnoofdays(diffInDays);
                calFinalTotal(diffInDays, rooamount);
            }
        }
    };

    const calFinalTotal = (days, roomamountxx) => {
        let total = parseFloat(days) * parseFloat(roomamountxx)
        settotalamount(total.toFixed(2));
        setremaining((total - advance).toFixed(2));
    }

    const handleroomtypeChange = async (value) => {
        setrtypeid(value);
        setamount(0);
        setroomrate(0);
        setdiscount(0);
        setdiscountupto(0);
        setroomid(""); // reset room selection

        const q = query(collection(db, 'roomdetails'), where('rtypeid', '==', value))
        onSnapshot(q, (querySnapshot) => {
            setrooms(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));
        });

        const q1 = query(collection(db, 'roomtarrifs'), where('rtypeid', '==', value))
        onSnapshot(q1, (querySnapshot) => {
            setplans(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));
        });
    }

    const handleplanChange = async (value) => {
        setplanid(value);
        try {
            const userDocRef = doc(db, 'roomtarrifs', value);
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                let rohamount = parseFloat(userDocSnap.data().amount);
                setamount(rohamount.toFixed(2));
                setroomrate(rohamount.toFixed(2));
                setdiscount(0);
                setdiscountupto(userDocSnap.data().discount);
            }
        } catch (error) {
            console.error('Error fetching document:', error);
        }
    }

    function caltotal(value) {
        setdiscount(value);
        if (value) {
            if (parseFloat(value) > parseFloat(discountupto)) {
                Toast.fire({ icon: "error", title: 'Discount should not be greater than ' + discountupto });
                setdiscount(discountupto);
                let roomr = parseFloat(amount) * parseFloat(discountupto) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
            } else {
                let roomr = parseFloat(amount) * parseFloat(value) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
            }
        } else {
            setdiscount(0)
            setroomrate(amount)
        }
    }

    const handleRoomArray = async () => {
        if (!roomid || !rtypeid || !planid || !amount || !roomrate) {
            Toast.fire({ icon: "error", title: 'Required all fields' });
            return;
        }

        let roomname = "";
        let roomtypename = "";
        let planname = "";

        const docRef = doc(db, "roomdetails", roomid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) roomname = docSnap.data().roomno;

        const docRef1 = doc(db, "roomtypes", rtypeid);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) roomtypename = docSnap1.data().roomtype;

        if (planid === 'EP OTA') planname = "EP OTA";
        else if (planid === 'CP OTA') planname = "CP OTA";
        else {
            const docRef2 = doc(db, "roomtarrifs", planid);
            const docSnap2 = await getDoc(docRef2);
            if (docSnap2.exists()) planname = docSnap2.data().rateplan;
        }

        const newItem = { roomid, rtypeid, planid, amount, discount, roomrate, roomname, roomtypename, planname, username: username };
        setbookingrooms([...bookingrooms, newItem]);
        
        setrtypeid(""); setroomid(""); setplanid(""); setamount(""); setdiscountupto(0); setdiscount(""); setroomrate("");
        
        setnoofrooms(bookingrooms.length + 1);
        
        let tamount = 0;
        for (let i = 0; i < bookingrooms.length; i++) {
            tamount += parseFloat(bookingrooms[i].roomrate);
        }
        let rxamount = parseFloat(tamount) + parseFloat(roomrate);
        
        setrooamount(rxamount.toFixed(2));
        calFinalTotal(noofdays, rxamount);
    }

    const handleamount1 = (e) => {
        let value = e.target.value || 0;
        let adv = parseFloat(value) + parseFloat(amount2 || 0);
        if (parseFloat(adv) > parseFloat(totalamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount cannot be greater than Total' });
            return;
        }
        setamount1(parseFloat(value, 10))
        setadvance(adv);
        let rem = parseFloat(totalamount) - parseFloat(adv);
        setremaining(rem.toFixed(2))
    }

    const handleamount2 = (e) => {
        let value = e.target.value || 0;
        let adv = parseFloat(amount1 || 0) + parseFloat(value);
        if (parseFloat(adv) > parseFloat(totalamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount cannot be greater than Total' });
            return;
        }
        setamount2(parseFloat(value, 10))
        setadvance(adv);
        let rem = parseFloat(totalamount) - parseFloat(adv);
        setremaining(rem.toFixed(2))
    }

    const removeItem = (itemToRemove) => {
        if (window.confirm(`Are you sure you want to remove room ${itemToRemove.roomname}?`)) {
            const updatedItems = bookingrooms.filter((item) => item !== itemToRemove);
            setbookingrooms(updatedItems);
            setnoofrooms(updatedItems.length);

            let tamount = 0;
            for (let i = 0; i < updatedItems.length; i++) {
                tamount += parseFloat(updatedItems[i].roomrate);
            }
            let rxamount = parseFloat(tamount);
            setrooamount(rxamount.toFixed(2))
            calFinalTotal(noofdays, rxamount);
        }
    };

    const checkoutReservation = async () => {
        if (!checkindate || !checkoutdate || !noofdays) {
            Toast.fire({ icon: "error", title: 'Please Select Checkin Date & Checkout Date ' });
            return;
        }
        if (!noofrooms) {
            Toast.fire({ icon: "error", title: 'Please Select at least 1 Room' });
            return;
        }
        if (!custname || !mobile || !address || !city) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in customer details' });
            return;
        }

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Invalid advance amount' });
            return;
        }

        // Strict validation for UTR if advance is paid
        if (advance > 0 && payStatus === 'Paid') {
            if (parseFloat(amount1) > 0 && (!paymode1 || !amount1 || !utr1)) {
                Toast.fire({ icon: "error", title: 'Payment Mode, Amount, and UTR are compulsory for Payment 1' });
                return;
            }
            if (parseFloat(amount2) > 0 && (!paymode2 || !amount2 || !utr2)) {
                Toast.fire({ icon: "error", title: 'Payment Mode, Amount, and UTR are compulsory for Payment 2' });
                return;
            }
        }

        setIsLoading(true);
        try {
            const customerData = {
                custname: custname, mobile: mobile, email: email, address: address, city: city, state: state,
                gender: gender, gstname: gstname, gstno: gstno, documenttype: documenttype, idno: idno,
                visitpurpose: visitpurpose, bookingsource: bookingsource, uid: userData.uid, createdAt: Timestamp.now(),
            };

            const customerRef = await addDoc(collection(db, 'customers'), {
                customerData,
            });

            const bookingRef = await addDoc(collection(db, 'advancebookings'), {
                customerId: customerRef.id, customers: customerData, rooms: bookingrooms, services: [],
                checkindate: checkindate, checkoutdate: checkoutdate, noofdays: noofdays, checkintime: checkintime,
                checkouttime: checkouttime, adults: adults, visitpurpose: visitpurpose, bookingsource: bookingsource,
                childs: childs, noofrooms: noofrooms, visitorPhotoUrl: visitorPhotoUrl, idFrontUrl: idFrontUrl,
                idBackUrl: idBackUrl, couplePhotoUrl: couplePhotoUrl, rooamount: parseFloat(rooamount),
                totalamount: parseFloat(totalamount), serviceamount: 0, restoamount: 0, advance: parseFloat(advance),
                remaining: parseFloat(remaining), note: note, type: "GST", status: "Paid", approval1: "No",
                approval2: "No", approval3: "No", approval4: "No", extra1: "", extra2: "", extra3: "", extra4: "",
                utr1: utr1, utr2: utr2, // Saved UTRs
                uid: userData.uid, createdAt: Timestamp.now(),
            });

            for (let i = 0; i < noofdays; i++) {
                for (let j = 0; j < bookingrooms.length; j++) {
                    await addDoc(collection(db, 'checkindetails'), {
                        bookingid: bookingRef.id,
                        customerId: customerRef.id,
                        checkindate: moment(checkindate).add(i, 'days').format('YYYY-MM-DD'),
                        checkoutdate: moment(checkindate).add(i + 1, 'days').format('YYYY-MM-DD'),
                        roomtypeid: bookingrooms[j].rtypeid,
                        roomid: bookingrooms[j].roomid, // Vital for overlap checking
                        planid: bookingrooms[j].planid,
                        planname: bookingrooms[j].planname,
                        roomtype: bookingrooms[j].roomtypename,
                        uid: userData.uid,
                        username: username,
                        bookingType: bookingType,
                        status: bookingType === 'Confirm' ? 'Paid' : 'Unpaid',
                        createdAt: Timestamp.now(),
                    });
                }
            }

            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: bookingRef.id,
                    customerId: customerRef.id,
                    customers: customerData,
                    rooms: bookingrooms,
                    paymode1: paymode1, amount1: parseFloat(amount1), paytime1: paytime1, utr1: utr1,
                    paymode2: paymode2, amount2: parseFloat(amount2), paytime2: paytime2, utr2: utr2,
                    uid: userData.uid, username: username, createdAt: Timestamp.now(), note: note,
                    type: 'Advance Booking', paymenttype: "A", status: 'Working',
                });
            }

            Toast.fire({ icon: "success", title: 'Advance Booking successfully Done' });

            // Reset Everything
            setrooms([]); setplans([]); setbookingrooms([]); setActiveStep(0); 
            setcheckindate(moment().format('YYYY-MM-DD')); setcheckoutdate(moment().add(1, 'days').format('YYYY-MM-DD')); 
            setnoofdays(1); setcheckintime(moment().format('HH:mm A')); setcheckouttime('12:00 PM'); setadults(2);
            setchilds(0); setnoofrooms(0); setcustname(""); setmobile(""); setemail(""); setaddress(""); setcity(""); 
            setstate("Maharashtra"); setgender("Male"); setvisitpurpose("Darshan"); setgstname(""); setgstno(""); 
            setbookingsource("Walking"); setdocumenttype(""); setidno(""); setvisitorPhotoUrl(''); setidFrontUrl(''); 
            setidBackUrl(''); setcouplePhotoUrl(''); setpaymode1(""); setamount1(0); 
            setpaytime1(moment().format('YYYY-MM-DD HH:mm A')); setutr1(""); setpaymode2(""); setamount2(0); 
            setpaytime2(moment().format('YYYY-MM-DD HH:mm A')); setutr2(""); setrooamount(0); setadvance(0); setremaining(0); 
            setnote(""); setrtypeid(""); setroomid(""); setplanid(""); setamount(""); setdiscountupto(0); setdiscount(""); setroomrate("");

        } catch (error) {
            Toast.fire({ icon: "error", title: 'Error: ' + error.message });
            console.log(error.message);
        }
        setIsLoading(false)
    }

    const handleCopmany = async (e) => {
        setcompanyid(e.target.value);
        if (e.target.value) {
            const docProdRef1 = doc(db, 'companydetails', e.target.value);
            const docSnap = await getDoc(docProdRef1);
            if (docSnap.exists()) {
                setgstname(docSnap.data().gstname);
                setgstno(docSnap.data().gstno);
            }
        }
    }

    const handleamount = (e) => {
        setamount(e.target.value);
        setdiscount(0);
        setroomrate(e.target.value);
    }

    const fetchCustomer = async () => {
        if (!search) {
            Toast.fire({ icon: "error", title: "Enter Mobile / Name / ID" });
            return;
        }
        try {
            const customersRef = collection(db, "customers");
            const q = query(
                customersRef,
                where("customerData.mobile", "==", search),
                orderBy("customerData.createdAt", "desc"),
                limit(1)
            );
            const snapshot = await getDocs(q);
            if (!snapshot.empty) {
                const data = snapshot.docs[0].data().customerData;
                setcustname(data.custname || "");
                setmobile(data.mobile || "");
                setemail(data.email || "");
                setaddress(data.address || "");
                setcity(data.city || "");
                setstate(data.state || "Maharashtra");
                setgender(data.gender || "Male");
                setvisitpurpose(data.visitpurpose || "Darshan");
                setgstname(data.gstname || "");
                setgstno(data.gstno || "");
                setbookingsource(data.bookingsource || "Walking");
                setdocumenttype(data.documenttype || "");
                setidno(data.idno || "");
            } else {
                Toast.fire({ icon: "error", title: "Customer Not Found" });
            }
        } catch (error) {
            console.error(error);
        }
    };

    // Filter available rooms dynamically based on database matches OR current temporary list
    const availableRooms = rooms.filter(room => 
        !bookedRoomsDb.includes(room.id) && 
        !bookingrooms.find(br => br.roomid === room.id)
    );

    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: "#f4f6f9", padding: "10px" }}>
                <section className="content">
                    <div className="container-fluid">
                        <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold', color: '#333' }}>
                            Future Reservation
                        </Typography>
                        
                        <Paper elevation={3} sx={{ padding: 2, borderRadius: 2 }}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                            
                            <Box mt={4}>
                                {isLoading && (
                                    <div style={overlayStyle}>
                                        <ClipLoader color="#36d7b7" size={60} />
                                    </div>
                                )}
                                
                                {activeStep === 0 && (
                                    <Grid container spacing={3}>
                                        {/* Date / Time Card */}
                                        <Grid item xs={12} md={4}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography variant="h6" gutterBottom>Booking Schedule</Typography>
                                                    <TextField fullWidth margin="normal" color="secondary" inputProps={{ min: today }} label="Check-In Date" type='date' value={checkindate} onChange={handleDate1Change} size='small' InputLabelProps={{ shrink: true }} />
                                                    <TextField fullWidth margin="normal" color="secondary" inputProps={{ min: today }} label="Check-Out Date" type='date' value={checkoutdate} onChange={handleDate2Change} size='small' InputLabelProps={{ shrink: true }} />
                                                    <TextField fullWidth margin="normal" label="No. Of Days" type='text' value={noofdays} size='small' InputProps={{ readOnly: true }} />
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        {/* Times Card */}
                                        <Grid item xs={12} md={4}>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h6" gutterBottom>Timing</Typography>
                                                    <TextField fullWidth margin="normal" type='text' value={checkintime} onChange={(e) => setcheckintime(e.target.value)} label="Check-In Time" size='small' />
                                                    <TextField fullWidth margin="normal" type='text' value={checkouttime} onChange={(e) => setcheckouttime(e.target.value)} label="Check-Out Time" size='small' />
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        {/* Guests Card */}
                                        <Grid item xs={12} md={4}>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h6" gutterBottom>Guests & Rooms</Typography>
                                                    <Grid container alignItems="center" spacing={2} sx={{ mb: 2 }}>
                                                        <Grid item xs={4}><Typography>Adults</Typography></Grid>
                                                        <Grid item xs={8} display="flex" alignItems="center">
                                                            <Button size="small" variant="outlined" color="error" onClick={() => setadults(adults > 1 ? adults - 1 : 1)}>-</Button>
                                                            <Typography sx={{ mx: 2, fontWeight: 'bold' }}>{adults}</Typography>
                                                            <Button size="small" variant="outlined" color="info" onClick={() => setadults(adults + 1)}>+</Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container alignItems="center" spacing={2} sx={{ mb: 2 }}>
                                                        <Grid item xs={4}><Typography>Childs</Typography></Grid>
                                                        <Grid item xs={8} display="flex" alignItems="center">
                                                            <Button size="small" variant="outlined" color="error" onClick={() => setchilds(childs > 0 ? childs - 1 : 0)}>-</Button>
                                                            <Typography sx={{ mx: 2, fontWeight: 'bold' }}>{childs}</Typography>
                                                            <Button size="small" variant="outlined" color="info" onClick={() => setchilds(childs + 1)}>+</Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container alignItems="center" spacing={2}>
                                                        <Grid item xs={4}><Typography>Rooms</Typography></Grid>
                                                        <Grid item xs={8}>
                                                            <Typography sx={{ ml: 2, fontWeight: 'bold' }}>{noofrooms}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        {/* Room Selection Form */}
                                        <Grid item xs={12}>
                                            <Card variant="outlined">
                                                <CardContent>
                                                    <Typography variant="h6" gutterBottom>Select Rooms</Typography>
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12} sm={6} md={2}>
                                                            <FormControl fullWidth size="small">
                                                                <InputLabel>Room Type</InputLabel>
                                                                <Select value={rtypeid} onChange={(e) => handleroomtypeChange(e.target.value)} label="Room Type">
                                                                    {roomtypes.map((item, i) => <MenuItem key={i} value={item.id}>{item.data.roomtype}</MenuItem>)}
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={2}>
                                                            <FormControl fullWidth size="small">
                                                                <InputLabel>Room No.</InputLabel>
                                                                <Select value={roomid} onChange={(e) => setroomid(e.target.value)} label="Room No.">
                                                                    {availableRooms.map((item, i) => <MenuItem key={i} value={item.id}>{item.data.roomno}</MenuItem>)}
                                                                    {availableRooms.length === 0 && rtypeid !== "" && (
                                                                        <MenuItem disabled>All booked for dates</MenuItem>
                                                                    )}
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={2}>
                                                            <FormControl fullWidth size="small">
                                                                <InputLabel>Plan</InputLabel>
                                                                <Select value={planid} onChange={(e) => handleplanChange(e.target.value)} label="Plan">
                                                                    <MenuItem value="CP OTA">CP OTA</MenuItem>
                                                                    <MenuItem value="EP OTA">EP OTA</MenuItem>
                                                                    {plans.map((item, i) => <MenuItem key={i} value={item.id}>{item.data.rateplan}</MenuItem>)}
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={2}>
                                                            <TextField fullWidth type="number" label="Amount" size="small" value={amount} onChange={handleamount} InputProps={{ readOnly: planid !== 'EP OTA' && planid !== 'CP OTA' }} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={1.5}>
                                                            <TextField fullWidth type="number" label="Discount %" size="small" value={discount} onChange={(e) => caltotal(e.target.value)} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={1.5}>
                                                            <TextField fullWidth type="number" label="Final Rate" size="small" value={roomrate} InputProps={{ readOnly: true }} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={1}>
                                                            <Button fullWidth variant="contained" color="info" onClick={handleRoomArray}>Add</Button>
                                                        </Grid>
                                                    </Grid>

                                                    {/* Selected Rooms Table */}
                                                    {bookingrooms.length > 0 && (
                                                        <TableContainer component={Paper} sx={{ mt: 3 }} variant="outlined">
                                                            <Table size="small">
                                                                <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                                                    <TableRow>
                                                                        <TableCell><b>Type</b></TableCell>
                                                                        <TableCell><b>Room No</b></TableCell>
                                                                        <TableCell><b>Plan</b></TableCell>
                                                                        <TableCell><b>Amount</b></TableCell>
                                                                        <TableCell><b>Disc %</b></TableCell>
                                                                        <TableCell><b>Rate</b></TableCell>
                                                                        <TableCell align="center"><b>Action</b></TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {bookingrooms.map((item, i) => (
                                                                        <TableRow key={i}>
                                                                            <TableCell>{item.roomtypename}</TableCell>
                                                                            <TableCell>{item.roomname}</TableCell>
                                                                            <TableCell>{item.planname}</TableCell>
                                                                            <TableCell>₹{item.amount}</TableCell>
                                                                            <TableCell>{item.discount}%</TableCell>
                                                                            <TableCell>₹{item.roomrate}</TableCell>
                                                                            <TableCell align="center">
                                                                                <IconButton color="error" size="small" onClick={() => removeItem(item)}>
                                                                                    <i className='fa fa-trash'></i>
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                )}

                                {activeStep === 1 && (
                                    <Card variant="outlined">
                                        <CardContent>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <Box display="flex" gap={2} alignItems="center">
                                                        <TextField label="Search Customer (Mobile)" size="small" sx={{ width: 300 }} value={search} onChange={(e) => setSearch(e.target.value)} />
                                                        <Button variant="contained" color="primary" onClick={fetchCustomer}>Fetch</Button>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}><Divider /></Grid>

                                                <Grid item xs={12} md={3}><TextField fullWidth color="secondary" value={custname} onChange={(e) => setcustname(e.target.value)} label="Customer Name" size="small" /></Grid>
                                                <Grid item xs={12} md={3}><TextField fullWidth color="secondary" value={mobile} onChange={handlemobile} label="Mobile" type="tel" size="small" /></Grid>
                                                <Grid item xs={12} md={3}><TextField fullWidth value={email} onChange={(e) => setemail(e.target.value)} label="Email" type="email" size="small" /></Grid>
                                                <Grid item xs={12} md={3}><TextField fullWidth color="secondary" value={address} onChange={(e) => setaddress(e.target.value)} label="Address" size="small" /></Grid>
                                                
                                                <Grid item xs={12} md={3}><TextField fullWidth color="secondary" value={city} onChange={(e) => setcity(e.target.value)} label="City" size="small" /></Grid>
                                                <Grid item xs={12} md={3}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel>State</InputLabel>
                                                        <Select value={state} onChange={(e) => setstate(e.target.value)} label="State">
                                                            <MenuItem value="Maharashtra">Maharashtra</MenuItem>
                                                            <MenuItem value="Delhi">Delhi</MenuItem>
                                                            <MenuItem value="Gujarat">Gujarat</MenuItem>
                                                            <MenuItem value="Karnataka">Karnataka</MenuItem>
                                                            {/* Add other states as needed */}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel>Gender</InputLabel>
                                                        <Select value={gender} onChange={(e) => setgender(e.target.value)} label="Gender">
                                                            <MenuItem value='Male'>Male</MenuItem>
                                                            <MenuItem value='Female'>Female</MenuItem>
                                                            <MenuItem value='Other'>Other</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel>Visit Purpose</InputLabel>
                                                        <Select value={visitpurpose} onChange={(e) => setvisitpurpose(e.target.value)} label="Visit Purpose">
                                                            <MenuItem value='Darshan'>Darshan</MenuItem>
                                                            <MenuItem value='Tourist'>Tourist</MenuItem>
                                                            <MenuItem value='Business'>Business</MenuItem>
                                                            <MenuItem value='Official'>Official</MenuItem>
                                                            <MenuItem value='Party'>Party</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel>Company Details</InputLabel>
                                                        <Select value={companyid} onChange={handleCopmany} label="Company Details">
                                                            <MenuItem value="">-- Select --</MenuItem>
                                                            {companydetails.map((item, i) => <MenuItem key={i} value={item.id}>{item.data.companyname}</MenuItem>)}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}><TextField fullWidth value={gstname} onChange={(e) => setgstname(e.target.value)} label="GST Name" size="small" /></Grid>
                                                <Grid item xs={12} md={3}><TextField fullWidth value={gstno} onChange={(e) => setgstno(e.target.value)} label="GST No" size="small" /></Grid>
                                                
                                                <Grid item xs={12} md={3}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel>Booking Source</InputLabel>
                                                        <Select value={bookingsource} onChange={(e) => setbookingsource(e.target.value)} label="Booking Source">
                                                            {bookingtypes.map((item, i) => <MenuItem key={i} value={item.data.bookingtype}>{item.data.bookingtype}</MenuItem>)}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}><TextField fullWidth color="secondary" label="Booking Date" type="date" value={bookingDate} onChange={(e) => setbookingDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} /></Grid>
                                                <Grid item xs={12} md={3}><TextField fullWidth color="secondary" value={documenttype} onChange={(e) => setdocumenttype(e.target.value)} label="Document Type" size="small" /></Grid>
                                                <Grid item xs={12} md={3}><TextField fullWidth color="secondary" value={idno} onChange={(e) => setidno(e.target.value)} label="ID No" size="small" /></Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                )}

                                {activeStep === 2 && (
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={4}>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h6" color="primary" gutterBottom>Customer Overview</Typography>
                                                    <Typography variant="body1"><b>{custname || "N/A"}</b></Typography>
                                                    <Typography variant="body2">{mobile}</Typography>
                                                    <Typography variant="body2" sx={{ mb: 2 }}>{email}</Typography>
                                                    <Divider sx={{ mb: 2 }} />
                                                    <Typography variant="body2"><b>Address:</b> {address} {city} {state}</Typography>
                                                    <Typography variant="body2"><b>Gender:</b> {gender}</Typography>
                                                    <Typography variant="body2"><b>Purpose:</b> {visitpurpose}</Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h6" color="primary" gutterBottom>Booking Summary</Typography>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={6}><Typography variant="body2">Check-In:</Typography></Grid>
                                                        <Grid item xs={6}><Typography variant="body2"><b>{checkindate}</b></Typography></Grid>
                                                        <Grid item xs={6}><Typography variant="body2">Check-Out:</Typography></Grid>
                                                        <Grid item xs={6}><Typography variant="body2"><b>{checkoutdate}</b></Typography></Grid>
                                                        <Grid item xs={6}><Typography variant="body2">Days:</Typography></Grid>
                                                        <Grid item xs={6}><Typography variant="body2"><b>{noofdays}</b></Typography></Grid>
                                                        <Grid item xs={6}><Typography variant="body2">Rooms:</Typography></Grid>
                                                        <Grid item xs={6}><Typography variant="body2"><b>{noofrooms}</b></Typography></Grid>
                                                        <Grid item xs={12}><Divider sx={{ my: 1 }} /></Grid>
                                                        <Grid item xs={6}><Typography variant="body1" color="success.main"><b>Total Amount:</b></Typography></Grid>
                                                        <Grid item xs={6}><Typography variant="body1" color="success.main"><b>₹{totalamount}</b></Typography></Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h6" color="primary" gutterBottom>Payment Setup</Typography>
                                                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                                        <InputLabel>Booking Type</InputLabel>
                                                        <Select value={bookingType} onChange={(e) => setbookingType(e.target.value)} label="Booking Type">
                                                            <MenuItem value="Confirm">Confirm</MenuItem>
                                                            <MenuItem value="Not Confirm">Not Confirm</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                                        <InputLabel>Payment Status</InputLabel>
                                                        <Select value={payStatus} onChange={(e) => setpayStatus(e.target.value)} label="Payment Status">
                                                            <MenuItem value="Paid">Paid</MenuItem>
                                                            <MenuItem value="Unpaid">Unpaid</MenuItem>
                                                            <MenuItem value="Pay At Hotel">Pay At Hotel</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    <TextField fullWidth value={note} onChange={(e) => setnote(e.target.value)} label="Note" size="small" />
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        {payStatus === 'Paid' && (
                                            <Grid item xs={12}>
                                                <Card variant="outlined" sx={{ backgroundColor: '#fdfdfd' }}>
                                                    <CardContent>
                                                        <Typography variant="h6" gutterBottom>Advance Payment Inputs</Typography>
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={12} md={4}>
                                                                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                                                    <InputLabel>Pay Mode 1</InputLabel>
                                                                    <Select value={paymode1} onChange={(e) => setpaymode1(e.target.value)} label="Pay Mode 1">
                                                                        {paymodes.map((item, i) => <MenuItem key={i} value={item.id}>{item.data.paymode}</MenuItem>)}
                                                                    </Select>
                                                                </FormControl>
                                                                <TextField fullWidth sx={{ mb: 2 }} value={amount1} label="Amount 1" onChange={handleamount1} type="number" size="small" />
                                                                <TextField fullWidth sx={{ mb: 2 }} required={parseFloat(amount1) > 0} value={utr1} onChange={(e) => setutr1(e.target.value)} label="UTR / Transaction No. 1" type="text" size="small" />
                                                                <TextField fullWidth value={paytime1} onChange={(e) => setpaytime1(e.target.value)} label="Payment Time 1" type="datetime-local" size="small" InputLabelProps={{ shrink: true }} />
                                                            </Grid>
                                                            <Grid item xs={12} md={4}>
                                                                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                                                    <InputLabel>Pay Mode 2 (Optional)</InputLabel>
                                                                    <Select value={paymode2} onChange={(e) => setpaymode2(e.target.value)} label="Pay Mode 2">
                                                                        <MenuItem value="">-- None --</MenuItem>
                                                                        {paymodes.map((item, i) => <MenuItem key={i} value={item.id}>{item.data.paymode}</MenuItem>)}
                                                                    </Select>
                                                                </FormControl>
                                                                <TextField fullWidth sx={{ mb: 2 }} value={amount2} label="Amount 2" onChange={handleamount2} type="number" size="small" />
                                                                <TextField fullWidth sx={{ mb: 2 }} required={parseFloat(amount2) > 0} value={utr2} onChange={(e) => setutr2(e.target.value)} label="UTR / Transaction No. 2" type="text" size="small" />
                                                                <TextField fullWidth value={paytime2} onChange={(e) => setpaytime2(e.target.value)} label="Payment Time 2" type="datetime-local" size="small" InputLabelProps={{ shrink: true }} />
                                                            </Grid>
                                                            <Grid item xs={12} md={4}>
                                                                <Box p={2} sx={{ backgroundColor: '#e3f2fd', borderRadius: 2 }}>
                                                                    <Typography variant="subtitle1" gutterBottom>Payment Calculation</Typography>
                                                                    <TextField fullWidth sx={{ mb: 2 }} value={advance} InputProps={{ readOnly: true }} label="Total Paid Amount" type="text" size="small" variant="filled" />
                                                                    <TextField fullWidth value={remaining} InputProps={{ readOnly: true }} label="Remaining Balance" type="text" size="small" variant="filled" />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        )}
                                    </Grid>
                                )}

                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 4 }}>
                                    <Button color="inherit" disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1 }} variant="outlined">
                                        Back
                                    </Button>
                                    <Box sx={{ flex: '1 1 auto' }} />
                                    {activeStep === steps.length - 1 ? (
                                        <Button variant="contained" color="success" onClick={checkoutReservation}>
                                            Save Advance Booking
                                        </Button>
                                    ) : (
                                        <Button variant="contained" onClick={handleNext}>
                                            Next Step
                                        </Button>
                                    )}
                                </Box>
                            </Box>
                        </Paper>
                    </div>
                </section>
            </div>
        </div>
    );
}

const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000, 
};